"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useCallback, useState, useEffect } from "react";
const ListBoxContext = createContext({
  selectedItems: [],
  setSelectedItems: () => void 0,
  handleChange: () => void 0,
  multiple: false,
  value: [],
  onChange: () => void 0
});
const ListBoxProvider = (props) => {
  const { multiple, value, children, onChange } = props;
  const [selectedItems, setSelectedItems] = useState(value || []);
  const handleChange = useCallback(
    (option, deselect, userInteraction) => {
      const newSelectedItems = !multiple ? [option] : deselect || selectedItems.includes(option) ? selectedItems.filter((selectedItem) => selectedItem !== option) : [...selectedItems, option];
      setSelectedItems(newSelectedItems);
      if (onChange && userInteraction) {
        onChange(newSelectedItems);
      }
    },
    [multiple, selectedItems, onChange]
  );
  useEffect(() => {
    if (value) {
      setSelectedItems(value);
    }
  }, [value]);
  return /* @__PURE__ */ jsx(
    ListBoxContext.Provider,
    {
      value: {
        selectedItems,
        setSelectedItems,
        handleChange,
        multiple,
        value
      },
      children
    }
  );
};
var ListBoxContext_default = ListBoxProvider;
export {
  ListBoxContext,
  ListBoxContext_default as default
};
